export { default as Venta } from "./Venta"
